export const cms = {
	// maps to Purchase a New Product, or the equivalent
	purchasNewProduct: 'miscText.purchase-header-reload-full',
};